import React from "react";
import AsyncGet from "../../../components/Materials/AsyncGet";
import { emptyProfile } from "../../../components/Images";

const ProfileImage = ({ loadImage = true, brokerId = "" }) => {
    return (
        <AsyncGet
            url={`/account/get-image`}
            paramsData={{ v: Date.now(), broker_id: brokerId }}
            permissionText="Account Get Image"
            loadOnMount={true}
            key={loadImage}
            responseType="blob"
            showToastOnError={false}
            render={({ data }) => {
                const blobData = new Blob([data]);
                const generatedUrl = URL.createObjectURL(blobData);
                return (
                    <img src={data !== false ? generatedUrl : emptyProfile} alt="PreviewImage" />
                )
            }}
        />
    )
}

export default ProfileImage;